module.exports = __webpack_public_path__ + "media/images/header-logo-25fd5b95582ac1e7e5191188167a6a92.png";